import * as React from 'react'

import Svg, { ClipPath, Defs, G, Path } from 'react-native-svg'

import { IconProps } from '../icons'

const HighQuality = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg width={16} height={16} fill={color} {...props}>
    <G clipPath="url(#a)">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="m8.948.91.952.713c.26.195.535.295.86.313l1.188.066c.712.04 1.29.525 1.452 1.218l.271 1.16c.075.316.22.569.458.791l.868.815c.52.488.65 1.23.329 1.866l-.537 1.062c-.147.29-.198.578-.159.901l.141 1.182a1.562 1.562 0 0 1-.947 1.641l-1.094.469c-.3.128-.523.316-.701.588l-.652.996a1.562 1.562 0 0 1-1.78.648l-1.14-.344a1.518 1.518 0 0 0-.914 0l-1.14.344a1.562 1.562 0 0 1-1.78-.648l-.652-.996a1.517 1.517 0 0 0-.7-.588l-1.095-.469a1.562 1.562 0 0 1-.947-1.641l.141-1.182a1.517 1.517 0 0 0-.159-.9L.674 7.851a1.562 1.562 0 0 1 .33-1.866l.867-.815c.237-.222.383-.475.458-.792L2.6 3.22a1.562 1.562 0 0 1 1.452-1.218l1.188-.066c.325-.018.6-.118.86-.313L7.052.91a1.562 1.562 0 0 1 1.896 0ZM7.392 8.408 6.358 7.374a.686.686 0 0 0-.97.97l1.52 1.52a.686.686 0 0 0 .971 0c.917-.916 1.823-1.843 2.735-2.763a.685.685 0 0 0-.972-.966l-2.25 2.273ZM8 2.888a5.095 5.095 0 0 0-3.614 1.498A5.095 5.095 0 0 0 2.89 7.999c0 1.412.572 2.69 1.497 3.614A5.095 5.095 0 0 0 8 13.11a5.095 5.095 0 0 0 3.614-1.497A5.095 5.095 0 0 0 13.11 8a5.095 5.095 0 0 0-1.497-3.613A5.095 5.095 0 0 0 8 2.889Zm3.26 1.851A4.596 4.596 0 0 0 8 3.39a4.596 4.596 0 0 0-3.26 1.35A4.596 4.596 0 0 0 3.39 8c0 1.274.515 2.426 1.35 3.26A4.596 4.596 0 0 0 8 12.61a4.596 4.596 0 0 0 3.26-1.35A4.596 4.596 0 0 0 12.61 8a4.596 4.596 0 0 0-1.35-3.26Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h16v16H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default HighQuality
